export default __webpack_public_path__ + "static/media/logo.f308086a.png";